import { connect } from 'react-redux'
import { IDailyTripLogReq, IStoreState } from '../../types'
import { getDailyTripLog } from '../../state/actions/trips'
import { Access2CareTripLogPDF } from 'src/components/services/view/pdfs/Access2CareTripLogPDF'
export function mapStateToProps(state: IStoreState, ownProps: any): any {
  return {
    isFetching: state.trips.isFetching,
    dailyTripLogs: state.trips.dailyTripLogs
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    getDailyTripLogs: (params: IDailyTripLogReq) => dispatch(getDailyTripLog(params))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Access2CareTripLogPDF)



// WEBPACK FOOTER //
// ./src/containers/services/Access2Care.ts